
// max players in a team
export const MAX_TEAM_PLAYERS = 5
// extra play time for all teams (+- intro duration)
export const EXTRA_PLAY_TIME = 5 * 60
// max players in the intro room
export const MAX_INTRO_PLAYERS = 19
// min players that can register
export const MIN_REGISTER_PLAYERS = 1
// max players that can register (will be split into teams)
export const MAX_REGISTER_PLAYERS = 20
// max length of a player name
export const MAX_PLAYER_NAME_LENGTH = 4
// max length of a team name
export const MAX_TEAMNAME_LENGTH = 10
// how much time can a team be too late (in minutes) before it's displayed on the signage screen
export const MAX_TEAM_LATE_TIME = 10
// amount of booster team gets at the start
export const BOOSTERS = 3
// multiplier for a the bonus room score
export const BONUS_ROOM_MULTIPLIER = 2
// max times a team can play a game (aka, worst idea ever)
export const MAX_GAMEPLAYS = 2
// a new timeslot starts every TIMESLOT_DELTA (in seconds)
export const TIMESLOT_DELTA = 5 * 60
// if the current timestamp is too close (eg 5 minutes) to the picked slot, the next slot is used otherwise
// the team has not enough time to finish the registration
export const NEXT_SLOT_DELTA = 5 * 60
// biggest team number (each team has it's own number in case the same team name is selected)
export const MAX_TEAM_NUMBER = 999
// the available playtimes (in seconds)
export const PLAY_TIMES = [3600, 5400, 7200]
// minimum percentage required to win the game
export const OUTRO_SCORE = 50
// max leaderboard entries
export const LEADERBOARD_MAX_TEAMS = 10
// max leaderboard individual entries
export const LEADERBOARD_MAX_PLAYERS = 10
// reset timer in the outro
export const OUTRO_RESET_TIME = 45
// reset timer in the game over screen
export const GAME_OVER_RESET_TIME = 15
// all the game ids
export const GAMES_LIST = [
    "game01",
    "game02",
    "game03",
    "game04",
    "game05",
    "game06",
    "game07",
    "game09",
    "game10",
    "game11",
    "game12",
    "game16",
    "game17",
    "game19",
    "game20",
    "game21",
    "game23",
    "game25",
    "game26",
    "game27",
    "game30",
    "game32",
    "game33",
    "game36",
    "game44",
    "game55",
    "game58"
]
// every X seconds the progress is emitted to arnet
export const PROGRESS_EMIT_INTERVAL = 5
// socket io room with realtime data
export const GAME_UPDATE_ROOM = "game-update-room"
